import {
    Loading,
    Message,
    MessageBox
} from 'element-ui';
export default {
    loading(msg){
        return Loading.service({
            lock: true,
            text: msg || '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
        });
    },
    jisuanlLoading(msg){
        return Loading.service({
            lock: true,
            text: msg || '拼命计算中，请勿刷新页面！',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
        });
    },
    closeLoading(load){
        load.close();
    },
    alert(msg,fn1,fn2){
        this._alert(1,msg,fn1,fn2);
    },
    alerts(msg,fn1,fn2){
        this._alert(2,msg,fn1,fn2);
    },
    alerte(msg,fn1,fn2){
        this._alert(3,msg,fn1,fn2);
    },
    msg(msg,fn){
        this._msg(1,msg,fn);
    },
    msgs(msg,fn){
        this._msg(2,msg,fn);
    },
    msge(msg,fn){
        this._msg(3,msg,fn);
    },
    _alert(flag=1,msg,fn1,fn2){
        var type = 'warning';
        if(flag == 2){
            type = 'success';
        }else if(flag==3){
            type = 'error';
        }
        MessageBox.alert(msg,'提示',{
            confirmButtonText: '确定',
            type:type,
            callback: action => {
                if(action=="confirm"){
                    fn1&&fn1();
                }else if(action == 'cancel'){
                    fn2&&fn2();
                }
            }
        })
    },
    _msg(flag=1,msg,fn1,d=5000){
        var type = 'info';
        if(flag == 2){
            type = 'success';
        }else if(flag==3){
            type = 'error';
        }
        Message({
            message: msg,
            type: type,
            showClose:true,
            duration: d,
            onClose:()=>{
                fn1&&fn1();
            }
        });
    },

    confirm(msg,fn1,fn2){
        this.cfm(msg||"?","提示","确认","取消",fn1,fn2)
    },
    cfm(title,msg,btn1,btn2,fn1,fn2){
        MessageBox.confirm(title,msg, {
            confirmButtonText: btn1,
            cancelButtonText: btn2,
            type: 'warning',
        }).then(() => {
            fn1&&fn1();
        }).catch(() => {
            fn2&&fn2();
        });
    }
}
